import React, { useEffect, useState } from 'react';
import {Notification} from '../assets/DataStructures';
import { 
    IonItem, 
    IonLabel, 
    IonDatetime,
    IonCard,
    IonCardContent,
    IonGrid,
    IonRow,
    IonCol,
    IonRadioGroup,IonRadio
  } from '@ionic/react';
import { Button, CardHeader, TextField, FormControlLabel, Checkbox } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import useStyles from '../assets/cssClasses';
import {firebase} from '../assets/firebase'

interface NotificationProps {
    propagateToParent: Function,
    onDelete: any,
    auto_notification: Notification,
    mode: string,
    saveParent: Function,
    id: string,
    survey_id: string,
}


const NotificationComponent: React.FC<NotificationProps> = (props) => {
    const [local, setLocal] = useState<Notification>(new Notification())
    const classes = useStyles();
    const [images, setImages] = useState<Array<{url: string, name: string}>>([]);
    const [mode, setMode] = useState<string>('view');

    useEffect(()=>{
        var store = firebase.storage()
        var imgs:Array<{url: string, name: string}> = [];
        
        store.ref('/alert_images').listAll().then(function(res) {
          res.items.forEach(function(itemRef) {
            itemRef.getDownloadURL().then(function(url){
              itemRef.getMetadata().then(function(metadata){
                imgs = [...imgs];
                imgs.push({name: metadata.name, url: url})
                console.log({name: metadata.name, url: url});
                
              }).then(function(){
                console.log("CALLED SET IMAGES")
                setImages(imgs);
              })
            });
            
          });
        }).catch(function(error) {
          console.log(error);
        });
    },[])


    useEffect(()=>{
        setMode(props.mode)
    },[props.mode])

    useEffect(()=>{
        console.log(images);
    },[images])

    const setAttr = (value: any, attr_name: string) => {
        var n_notification:Notification = Object.assign({}, local);
        n_notification[attr_name as keyof typeof local] = value;
        props.propagateToParent(n_notification);
        setLocal(n_notification)
    }

    useEffect(()=>{
        var n_notification:Notification = Object.assign({}, props.auto_notification);
        setLocal(n_notification);
    },[props.auto_notification])

    const setDay = (ind: number, val: boolean) => {
        var n_notification:Notification = Object.assign({}, local);
        n_notification.days_array[ind] = val;
        props.propagateToParent(n_notification);
        setLocal(n_notification);
    }

    const setTime = (val: any, key: string) => {
        if(val){
            console.log(val);
            
            setAttr(val, key);
        }
    }
 
    const checkboxList = [
        { val: 'Mon', isChecked: false },
        { val: 'Tue', isChecked: false },
        { val: 'Wed', isChecked: false },
        { val: 'Thu', isChecked: false },
        { val: 'Fri', isChecked: false },
        { val: 'Sat', isChecked: false },
        { val: 'Sun', isChecked: false },
      ];

    return(

        <IonCard className={classes.fancy_card}> 
            {mode==='view' && 
                <Button onClick={()=>setMode('edit')} className={classes.actionButton}>EDIT</Button>
            }
            
            
            {(mode==='edit' || mode==='new') && 
                <IonCardContent>
                <Card className={classes.grey_card}>
                    <CardHeader
                        title="Push Notification"
                        subheader=""
                        className={classes.card_header}
                    />
                    <CardContent>
                        <TextField id="title" label="Push Title" value={local.push_title} onChange={e => setAttr(e.target.value, 'push_title')} fullWidth={true} />
                        <TextField id="message" label="Push Message" value={local.push_message} onChange={e => setAttr(e.target.value, 'push_message')} fullWidth={true} />
                    </CardContent>
                </Card>

                <Card className={classes.grey_card}>
                    <CardHeader
                        title="Survey Options"
                        subheader=""
                        className={classes.card_header}
                    />

                    <CardContent>
                    
                    <TextField id="survey_status_message" label="Survey Status Message" value={local.survey_status_message} onChange={e => setAttr(e.target.value, 'survey_status_message')} fullWidth={true}/>
                    <IonLabel  className={classes.card_title}>
                         Action:
                    </IonLabel>
                        <IonRadioGroup onIonChange={e => setAttr(e.detail.value, 'action')} value={local.action}>
                            <IonItem>
                                <IonLabel>CLOSE survey</IonLabel>
                                <IonRadio value="CLOSE" />
                            </IonItem>

                            <IonItem>
                                <IonLabel>OPEN survey</IonLabel>
                                <IonRadio value="OPEN" />
                            </IonItem>

                            <IonItem>
                                <IonLabel>NONE</IonLabel>
                                <IonRadio value="NONE" />
                            </IonItem>

                        </IonRadioGroup>
                    </CardContent>
                </Card>


                <FormControlLabel
                    control={
                        <Checkbox
                        checked={local.modal?.valueOf()}
                        onChange={e => setAttr(e.target.checked, 'modal')}
                        name="checkedAuto"
                        color="primary"
                        />
                    }
                    label="Modal"
                    />

                {local.modal.valueOf() === true && 
                <Card className={classes.grey_card}>
                    <CardHeader
                        title="Modal"
                        subheader=""
                        className={classes.card_header}
                    />

                    <CardContent>
                        {images.map((img, ind)=>{
                            return(
                                <img src={img.url} alt="" key={'img'+img.name} width='100' onClick={e => setAttr(img.url, 'image_url')} className={img.url===local.image_url?classes.selected_image:undefined}/>
                            )
                        })}

                        <TextField id="modal_title" label="Modal Title" value={local.modal_title} onChange={e => setAttr(e.target.value, 'modal_title')} fullWidth={true}/>
                        <TextField id="modal_message" label="Modal Message" value={local.modal_message} onChange={e => setAttr(e.target.value, 'modal_message')} fullWidth={true}/>
                    </CardContent>
                </Card>

                }
                

 
                    
                {local.inactivity_reminder?.valueOf() !== true &&
                    <FormControlLabel
                    control={
                        <Checkbox
                        checked={local.auto?.valueOf()}
                        onChange={e => setAttr(e.target.checked, 'auto')}
                        name="checkedAuto"
                        color="primary"
                        />
                    }
                    label="Automation"
                    />
                }

                {local.auto.valueOf() === true && 
                <Card className={classes.grey_card}>
                    <CardHeader
                        title="Automation options"
                        subheader=""
                        className={classes.card_header}
                    />
                    <CardContent >
                        
                            <React.Fragment>
   
                                <TextField id="COND" label="CONDITION" value={local.cond} onChange={e => setAttr(e.target.value, 'cond')}  fullWidth={true}/>

                                 
                                    <IonLabel  className={classes.card_title}>
                                        Execute on:
                                    </IonLabel>
                              
                                {checkboxList.map(({ val, isChecked }, i) => (
                             
                                     
                                    
                                    <FormControlLabel
            control={<Checkbox slot="end" value={val} checked={local.days_array[i]} onChange={e => setDay(i, e.target.checked)} color='primary'/>}
            label={val}
          />
                         
                                ))}
                                
                                <IonLabel  className={classes.card_title}>
                                    Hour (GMT):
                                </IonLabel>
                          
                                <IonItem>
                                    <IonLabel>HH:mm</IonLabel>
                                    <IonDatetime 
                                    displayFormat="HH:mm"
                                    value={local.time}
                                    onIonChange={e => setTime(e.detail.value, 'time')}
                                    minuteValues="0,5,10,15,20,25,30,35,40,45,50,55"></IonDatetime>
                                </IonItem>
                                </React.Fragment>
                            
                    </CardContent>
                </Card>

                
                }
                {local.auto?.valueOf() !== true &&
                <FormControlLabel
                    control={
                        <Checkbox
                        checked={local.inactivity_reminder?.valueOf()}
                        onChange={e => setAttr(e.target.checked, 'inactivity_reminder')}
                        name="checkedAuto"
                        color="primary"
                        />
                    }
                    label="Inactivity reminder"
                    />
                }
                    {local.inactivity_reminder?.valueOf() === true && 

                        <Card className={classes.grey_card}>
                            <CardHeader
                                title="Inactivity reminder"
                                subheader=""
                                className={classes.card_header}
                            />
                            <CardContent >

                                        <TextField id="inactivity" label="Inactivity Days" value={local.inactivity_days} onChange={e => setAttr(e.target.value, 'inactivity_days')}  fullWidth={true}/>
                                        <IonLabel  className={classes.card_title}>
                                    Hour (GMT):
                                </IonLabel>
                                        <IonItem>
                                            <IonLabel>HH:mm</IonLabel>
                                            <IonDatetime 
                                            displayFormat="HH:mm"
                                            value={local.inactivity_execution_time}
                                            onIonChange={e => setTime(e.detail.value, 'inactivity_execution_time')}
                                            minuteValues="0,5,10,15,20,25,30,35,40,45,50,55"></IonDatetime>
                                        </IonItem>
                            </CardContent>
                        </Card>

                    }
                </IonCardContent>
            }

            

            {mode==='view' &&
                <IonCardContent>
                <Card className={classes.grey_card}>
                    <CardHeader
                        title="Push Notification"
                        subheader=""
                        className={classes.card_header}
                    />
                    <CardContent>
                    <IonGrid>
                        <IonRow>
                            <IonCol sizeLg="2" sizeMd="4">Title</IonCol>
                            <IonCol sizeLg="10" sizeMd="8">{local.push_title}</IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol sizeLg="2" sizeMd="4">Message</IonCol>
                            <IonCol sizeLg="10" sizeMd="8">{local.push_message}</IonCol>
                        </IonRow>
                    </IonGrid>
                    
                
                    </CardContent>
                </Card>

                <Card className={classes.grey_card}>
                    <CardHeader
                        title="Survey Options"
                        subheader=""
                        className={classes.card_header}
                    />

                    <CardContent>
                    
                     {local.survey_status_message} 
                    <IonLabel  className={classes.card_title}>
                         Action:
                    </IonLabel>
                         {local.action} 
                    </CardContent>
                </Card>



                {local.modal.valueOf() === true && 
                <Card className={classes.grey_card}>
                    <CardHeader
                        title="Modal"
                        subheader=""
                        className={classes.card_header}
                    />

                    <CardContent>
                        {images.map((img, ind)=>{
                            return(
                                <img src={img.url} alt="" key={'img'+img.name} width='100' className={img.url===local.image_url?classes.selected_image:undefined}/>
                            )
                        })}
                        <IonRow>
                            <IonCol sizeLg="2" sizeMd="4">Title</IonCol>
                            <IonCol sizeLg="10" sizeMd="8">{local.modal_title}</IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol sizeLg="2" sizeMd="4">Message</IonCol>
                            <IonCol sizeLg="10" sizeMd="8">{local.modal_message}</IonCol>
                        </IonRow>
                        
                        
                    </CardContent>
                </Card>

                }
                


                {local.auto.valueOf() === true && 
                <Card className={classes.grey_card}>
                    <CardHeader
                        title="Automation options"
                        subheader=""
                        className={classes.card_header}
                    />
                    <CardContent >
                        
                        
   
                                {local.cond}

                                 
                                    <IonLabel  className={classes.card_title}>
                                        Execute on:
                                    </IonLabel>
                              
                                {checkboxList.map(({ val, isChecked }, i) => (
                             
                                     
                                    
                                    <FormControlLabel
            control={<Checkbox slot="end" value={val} checked={local.days_array[i]} color='primary' disabled={true}/>}
            label={val}
          />
                         
                                ))}
                                
                                <IonLabel  className={classes.card_title}>
                                    Hour:
                                </IonLabel>
                          
                                <IonItem>
                                    <IonLabel>HH:mm</IonLabel>
                                     {(new Date(local.time)).getHours() + ":" + (new Date(local.time)).getMinutes()} 
                                </IonItem>


                         
                            
                    </CardContent>
                </Card>

                
                }
                {local.auto.valueOf() !== true &&
                    <Card className={classes.grey_card}>
                        <CardHeader
                            title="Python Snippet"
                            subheader=""
                            className={classes.card_header}
                        />
                        <CardContent >
                                <IonRow>
                                    <IonCol sizeLg="12" sizeMd="12">import requests</IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol sizeLg="12" sizeMd="12">myobj = &#123;'app_user_id': duid&#125;</IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol sizeLg="12" sizeMd="12">x = requests.post('http://dsm.bright-mr.com/diaries/{props.survey_id}/manual/{props.id}', data = myobj)</IonCol>
                                </IonRow>          
                        </CardContent>
                    </Card>
                }
                

                    {local.inactivity_reminder?.valueOf() === true && 

                    <Card className={classes.grey_card}>
                        <CardHeader
                            title="Inactivity reminder"
                            subheader=""
                            className={classes.card_header}
                        />
                        <CardContent >
                            <IonRow>
                                <IonCol sizeLg="2" sizeMd="4">Days</IonCol>
                                <IonCol sizeLg="10" sizeMd="8">{local.inactivity_days}</IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol sizeLg="2" sizeMd="4">Execution time</IonCol>
                                <IonCol sizeLg="10" sizeMd="8">{(new Date(local.inactivity_execution_time)).getHours() + ":" + (new Date(local.inactivity_execution_time)).getMinutes()}</IonCol>
                            </IonRow>
                                        
                                        
                            </CardContent>
                    </Card>

                    }
                </IonCardContent>
            }

            
            <CardActions>
                {mode==='view' && 
                    <Button onClick={props.onDelete} className={classes.delButton}>DEL</Button>
                }
                {mode==='edit' && 
                    <Button onClick={()=>{setMode('view'); props.saveParent()}} className={classes.actionButton}>SAVE</Button>
                }
            </CardActions>

                
        
        </IonCard>


    )
}


 
export {NotificationComponent}